module.exports = __webpack_public_path__ + "2c119104023f6c2cd3a2e43810d477ef.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/816.png
// module id = 1719
// module chunks = 2